import axios from 'axios';
import {
  BILL_MANAGEMNENT_LIST,
  CREATE_BILL_MANAGEMNENT_LIST,
  DETAIL_BILL_MANAGEMNENT_LIST,
  DETAIL_VENDER_BILL_LIST,
  PAYMENT_BILL_LIST,
  VENDER_BILL_LIST
} from '../../constant/API constant';

export const Bill_Management_List = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${BILL_MANAGEMNENT_LIST}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj
  });
};

export const Add_Bill_Management = (formData) => {
  const jwt_token = localStorage.getItem('token');
  return axios.post(`${process.env.REACT_APP_API_URL}${CREATE_BILL_MANAGEMNENT_LIST}`, formData, {
    headers: { Authorization: jwt_token }
  });
};

export const Edit_Bill_Management = (formData, vendorId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.put(`${process.env.REACT_APP_API_URL}${CREATE_BILL_MANAGEMNENT_LIST}`, formData, {
    headers: { Authorization: jwt_token },
    params: { vendorId }
  });
};

export const Delete_Bill_Management = (vendorId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.delete(`${process.env.REACT_APP_API_URL}${BILL_MANAGEMNENT_LIST}`, {
    headers: { Authorization: jwt_token },
    params: { vendorId }
  });
};

export const Bill_Management_Detail = (vendorId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${DETAIL_BILL_MANAGEMNENT_LIST}`, {
    headers: { Authorization: jwt_token },
    params: { vendorId }
  });
};

export const Vender_Bill_List = (paramsObj) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${VENDER_BILL_LIST}`, {
    headers: { Authorization: jwt_token },
    params: paramsObj
  });
};

export const Add_Vender_Bill = (formData) => {
  const jwt_token = localStorage.getItem('token');
  return axios.post(`${process.env.REACT_APP_API_URL}${VENDER_BILL_LIST}`, formData, {
    headers: { Authorization: jwt_token }
  });
};

export const Vender_Bill_Delete = ({ vendorId, vendorBillId }) => {
  const jwt_token = localStorage.getItem('token');
  return axios.delete(`${process.env.REACT_APP_API_URL}${VENDER_BILL_LIST}`, {
    headers: { Authorization: jwt_token },
    params: { vendorId, vendorBillId }
  });
};
export const Vender_Bill_Detail = ({ vendorId, vendorBillId }) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${DETAIL_VENDER_BILL_LIST}`, {
    headers: { Authorization: jwt_token },
    params: { vendorId, vendorBillId }
  });
};

export const Edit_Vender_Bill_Management = (formData, vendorBillId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.put(`${process.env.REACT_APP_API_URL}${VENDER_BILL_LIST}`, formData, {
    headers: { Authorization: jwt_token },
    params: { vendorBillId }
  });
};

export const payment_Bill_List = (vendorId, vendorBillId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.get(`${process.env.REACT_APP_API_URL}${PAYMENT_BILL_LIST}`, {
    headers: { Authorization: jwt_token },
    params: { vendorId, vendorBillId }
  });
};
export const Add_Payment_Bill = (formData) => {
  const jwt_token = localStorage.getItem('token');
  return axios.post(`${process.env.REACT_APP_API_URL}${PAYMENT_BILL_LIST}`, formData, {
    headers: { Authorization: jwt_token }
  });
};
export const payment_Bill_Delete = (billPaymentId) => {
  const jwt_token = localStorage.getItem('token');
  return axios.delete(`${process.env.REACT_APP_API_URL}${PAYMENT_BILL_LIST}`, {
    headers: { Authorization: jwt_token },
    params: { billPaymentId }
  });
};
